

export const tableSortConstants={
    TABLE_NUMBER_SORT: ['High to Low', 'Low to High'],
    TABLE_ALPHABET_SORT:['Z-A','A-Z'],
};